export default "__VITE_ASSET__BUrPOdt4__"